import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, ROLE_HOME } from '../../../Context/AuthContext';

// Spinner inline — pas de dépendance externe
const Spinner = () => (
  <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}>
    <div style={{
      width: 40, height: 40,
      border: '4px solid #e4e8ef',
      borderTopColor: '#1a4fc8',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

// ─────────────────────────────────────────────────────────────────────────────
// RoleRoute — garde RBAC générique
//
// Usage :
//   <RoleRoute roles={['CLIENT']}><UserHome /></RoleRoute>
//   <RoleRoute roles={['SUPER_ADMIN']}><AdminDashboard /></RoleRoute>
//   <RoleRoute roles={['ADMIN_COMPANY','SUPER_ADMIN']}><CompanyPage /></RoleRoute>
// ─────────────────────────────────────────────────────────────────────────────
const RoleRoute = ({ children, roles }) => {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Spinner />;

  if (!isAuthenticated) {
    // Sauvegarder la destination pour redirect post-login
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  if (!roles.includes(role)) {
    // Rediriger vers l'espace correct du rôle authentifié
    const home = ROLE_HOME[role];
    if (home) return <Navigate to={home} replace />;
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default RoleRoute;
